<ion-list *ngIf="links?.length > 0">
	<ion-list-header *ngIf="title">
		<ion-label> {{title}} </ion-label>
	</ion-list-header>
	<calao-link *ngFor="let link of links" [linkInfo]="link" (click)="close()"></calao-link>
</ion-list>